module.exports = __webpack_public_path__ + "static/media/ER.cc0cfad0.svg";